<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div v-if="inputForm.dictType !== 'hr_salary_icon'">
        <van-field v-if="inputForm.dictType !== 'hr_labor_std_day'" v-model="inputForm.label" :label="labelName"
                   label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="inputForm.dictType !== 'hr_labor_std_day'" v-model="inputForm.useFlagLabel" label="是否启用"
                   label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>

        <van-field v-if="inputForm.dictType === 'hr_labor_std_day'" v-model="inputForm.label"
                   label="劳务用工日薪标准名称" label-width="110px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-if="inputForm.dictType === 'hr_labor_std_day'" v-model="inputForm.value" label="劳务用工日薪标准"
                   label-width="110px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </div>


      <div v-if="inputForm.dictType === 'hr_salary_icon'">
        <van-field v-model="inputForm.label" label="考勤类型" label-width="110px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.useFlagLabel" label="是否启用" label-width="110px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.value" label="考勤符号-文本" label-width="110px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field label="考勤符号-图示" label-width="100px" readonly input-align="left" :border="false" autosize
                   rows="1" type="textarea">
          <template #input>
            <div style="display: flex;flex-wrap: wrap;">
              <i :class="inputForm.value" style="font-size: 40px"></i>
            </div>
          </template>
        </van-field>
      </div>

    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "HrSysDictValue",
  data() {
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'sys_dict_value',
      /*
      ToDo: 职务名称目录、考勤员权限设置、法定节假日信息目录、考勤符号类型目录、社保公积金比例设置、薪酬权限设置、年终红包出勤占比比例设置、劳务用工日新标准、延时加班费计算标准
      */
      mapData: {
        'hr_appeal_type': '申诉类别名称',
        'hr_dispute_type': '争议处理类别名称',
        'hr_station_type': '岗位类型名称',
        'hr_station_property': '岗位性质名称',
        'hr_edu_level': '学历信息名称',
        'hr_edu_year': '学制信息名称',
        'hr_degree_type': '学位类型名称',
        'hr_hire_way': '招聘渠道名称',
        'hr_hire_plan_type': '计划类型名称',
        'hr_politic_visgae': '政治面貌名称',
        'hr_hire_study_type': '学习形式名称',
        'hr_hire_leave_type': '离职类型名称',
        'hr_hire_talk_type': '访谈类型名称',
        'hr_dossier_type': '人事档案类别名称',
        'hr_contract_property': '劳动合同性质名称',
        'hr_contract_type': '劳动合同类型名称',
        'hr_contract_sign_type': '劳动合同签订类型名称',
        'hr_contract_fulfil_status': '劳动合同履行状态名称',
        'hr_contract_append_list': '劳动合同补充协议目录名称',
        'hr_train_type': '培训形式类型名称',
        'hr_train_class_type': '培训课程类型名称',
        'hr_train_method_type': '培训方式类型名称',
        'hr_train_dept_type': '培训机构类型名称',
        'hr_train_lectuer_inner': '培训讲师类型名称',
        'hr_train_lectuer_external': '培训讲师类型名称',
        'hr_train_material_type': '培训教材类型名称',
        'hr_train_adjust_type': '培训计划调整类型',
        'hr_param_profession': '专业技术资格类型名称',
        'hr_cert_type_prac': '执业资格类型名称',
        'hr_cert_type_special': '特殊工种类型名称',
        'hr_cert_type_other': '其他证书类型名称',
        'hr_cert_type': '证书类型名称',
        'hr_cert_ues_type': '证书保管类型名称',
        'hr_holiday_type': '假期类型目录名称',
        'hr_bonus_gsdk_type': '扣缴方式名称',
        'hr_weal_list': '福利名称',
        'hr_labor_std_day': '劳务用工日薪标准名称'
      }
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  computed: {
    labelName() {
      return this.mapData[this.inputForm.dictType] || '选项值'
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/hr/basic/hrSysDictValue/queryById').then(({data}) => {
        this.inputForm = data
        // if (!data.attachIds) {
        //   this.inputForm.attachList = []
        // }
        this.getDict([
          ['hr_comm_use_flag', 'useFlag'],
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          // 判空处理：只有当表单字段有值时才处理
          if (this.inputForm[formField] !== null && this.inputForm[formField] !== undefined && this.inputForm[formField] !== '') {
            const dictList = data[dictType] || [];
            const dictItem = dictList.find(item => item.value == this.inputForm[formField]);
            this.$set(this.inputForm, `${formField}Label`, dictItem ? dictItem.label : '');
          } else {
            // 表单字段为空时，清空标签字段
            this.$set(this.inputForm, `${formField}Label`, '');
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/hr/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/hr/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped>

</style>